import { render, staticRenderFns } from "./MyLoader.vue?vue&type=template&id=f1f63754&scoped=true&"
import script from "./MyLoader.vue?vue&type=script&lang=js&"
export * from "./MyLoader.vue?vue&type=script&lang=js&"
import style0 from "./MyLoader.vue?vue&type=style&index=0&id=f1f63754&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1f63754",
  null
  
)

export default component.exports